import { Form } from 'antd';
import { LockOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { UiButton, UiTextBox } from '../../../components';
import '../style.scss';

const SetPassword = ({
    onSubmit,
    loading,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    isFormValid,
    onFormChange,
    onFormFailed,
    form,
}) => {

    const onFinish = (values) => {
        if (onSubmit) onSubmit(values);
    };

    const onFinishFailed = () => {
        if (onFormFailed) onFormFailed();
    };

    return (
        <>
            <div className="forget-password-content-title">
                Set New Password
            </div>
            <div className="forget-password-content-subtitle">
                Create a strong password for your account. Please ensure both passwords match.
            </div>
            <Form
                form={form}
                name="setPassword"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onFieldsChange={onFormChange}
                autoComplete="off"
                layout="vertical"
                size="large"
                className="forget-password-form"
            >
                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter a password',
                        },
                        {
                            min: 8,
                            message: 'Password must be at least 8 characters long',
                        },
                        {
                            max: 16,
                            message: 'Password cannot exceed 16 characters',
                        },
                        {
                            pattern: /^(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,16}$/,
                            message: 'Password must contain at least one uppercase letter and one special character',
                        },
                    ]}
                    className="forget-password-form-item"
                    style={{ 'padding': '0px 0px 0px 0px' }}
                >
                    <UiTextBox
                        placeholder="password"
                        type={showPassword ? 'text' : 'password'}
                        maxLength={16}
                        prefix={<LockOutlined style={{ marginRight: 8 }} />}
                        suffix={
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                onMouseDown={(event) => event.preventDefault()}
                                style={{ cursor: 'pointer' }}
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                role="button"
                            >
                                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            </span>
                        }
                        className="forget-password-input"
                    />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password',
                        },
                        {
                            validator: (_, value) => {
                                const password = form.getFieldValue('password');
                                if (value && password && value !== password) {
                                    return Promise.reject(new Error('Passwords do not match'));
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                    className="forget-password-form-item"
                    style={{ 'padding': '0px 0px 0px 0px' }}
                >
                    <UiTextBox
                        placeholder="Confirm password"
                        type={showConfirmPassword ? 'text' : 'password'}
                        maxLength={16}
                        prefix={<LockOutlined style={{ marginRight: 8 }} />}
                        suffix={
                            <span
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                onMouseDown={(event) => event.preventDefault()}
                                style={{ cursor: 'pointer' }}
                                aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
                                role="button"
                            >
                                {showConfirmPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            </span>
                        }
                        className="forget-password-input"
                    />
                </Form.Item>
                <Form.Item className="forget-password-form-item">
                    <UiButton
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={!isFormValid}
                        className={`forget-password-submit-button ${isFormValid ? 'forget-password-submit-button-enabled' : ''}`}
                    >
                        Submit
                    </UiButton>
                </Form.Item>
            </Form>
        </>
    );
};

export default SetPassword;
